<template>
    <div class="modal is-active">
        <figure class="loading is-32x32">
            <img width="32" height="32" src="/img/35.gif" alt="">
        </figure>
    </div>
</template>

<script>
    export default {
        name: "Loader"
    }
</script>

<style scoped>
    .loading {
        isplay: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        width: 100%;
        text-align: center;
        margin: 10% 0;
        min-height: 64px;
        align-items: center;
    }
</style>